import React, { useCallback } from 'react';
import styled from 'styled-components';

import {
  Accordion,
  AccordionProps,
  ArrowDownIcon,
  FlexRow,
  SvgIcon,
} from '@make-software/cspr-design';

const StyledAccordion = styled(Accordion)(({ theme }) =>
  theme.withMedia({
    padding: ['16px 32px', '16px 48px', '0 12px', '0 22px'],
  })
);

const ArrowSvgIcon = styled(SvgIcon)<{ isOpen: boolean }>(
  ({ theme, isOpen }) => ({
    path: {
      fill: isOpen
        ? theme.styleguideColors.contentOnFill
        : theme.styleguideColors.contentTertiary,
    },
  })
);

const defaultBackgroundColor = 'rgba(26, 25, 25, 0.2)';

interface NavAccordionProps
  extends Pick<AccordionProps, 'backgroundColor' | 'children' | 'onClick'> {
  itemList?: { handleClick?: () => void; component: React.ReactNode }[];
}

export function NavAccordion({
  backgroundColor = defaultBackgroundColor,
  children,
  itemList,
  onClick,
}: NavAccordionProps) {
  const onAccordionClick = useCallback(
    (state) => {
      onClick && onClick(state);
    },
    [onClick]
  );

  return (
    <StyledAccordion
      onClick={onAccordionClick}
      backgroundColor={backgroundColor}
      renderContent={({ isOpen }) =>
        isOpen &&
        itemList &&
        itemList.map(({ handleClick, component }, index) => (
          <div
            key={index}
            onClick={handleClick && handleClick}
            style={{ marginBottom: 16 }}
          >
            {component}
          </div>
        ))
      }
    >
      {(renderProps) => (
        <FlexRow
          style={{ marginBottom: renderProps.isOpen ? 24 : 0 }}
          align="center"
        >
          {children(renderProps)}
          <ArrowSvgIcon
            src={ArrowDownIcon}
            alt={'Arrow down icon'}
            style={{ marginLeft: 8 }}
            isOpen={renderProps.isOpen}
            rotate={renderProps.isOpen}
          />
        </FlexRow>
      )}
    </StyledAccordion>
  );
}

export default NavAccordion;
